import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get theme() {
    return localStorage.getItem('theme') || 'default-theme';
  }

  set theme(value) {
    localStorage.setItem('theme', value);
    window.dispatchEvent(
      new CustomEvent('culture-cal-theme-change', { detail: { theme: value } }),
    );
  }

  initialize() {
    this.changeTheme = this.changeTheme.bind(this);
    this.restore = this.restore.bind(this);
  }

  connect() {
    this.originalTheme = this.theme;
  }

  changeTheme(e) {
    this.theme = e.target.value;
  }

  restore() {
    this.theme = this.originalTheme;
  }
}
